import * as zod from 'zod';

import { PayloadState } from '@sb/routine-runner/types/PayloadState';

export const DisableGripperArguments = zod.object({
  payload: PayloadState.nullable().default(null),
});

export type DisableGripperArguments = zod.infer<typeof DisableGripperArguments>;
